import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { NOXO_PLACEHOLDERS_VISIBLE } from './placeholders-visible';

export const provideNoxoPlaceholders = (): EnvironmentProviders =>
  makeEnvironmentProviders([{ provide: NOXO_PLACEHOLDERS_VISIBLE, useValue: true }]);
